var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 50 50",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 16a10 10 0 1 0 10 10 10 10 0 0 0 -10-10zm0 18a8 8 0 1 1 8-8 8 8 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 12h-4.38l-.83-1.66a4.58 4.58 0 0 0 -3.79-2.34h-8a4.58 4.58 0 0 0 -3.79 2.34l-.83 1.66h-4.38a7 7 0 0 0 -7 7v16a7 7 0 0 0 7 7h26a7 7 0 0 0 7-7v-16a7 7 0 0 0 -7-7zm5 23a5 5 0 0 1 -5 5h-26a5 5 0 0 1 -5-5v-16a5 5 0 0 1 5-5h5a1 1 0 0 0 .89-.55l1.11-2.21a2.56 2.56 0 0 1 2-1.24h8a2.56 2.56 0 0 1 2 1.24l1.11 2.21a1 1 0 0 0 .89.55h5a5 5 0 0 1 5 5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.30b9b1bc0fc5fd6a389bb523444e6573.svg";
export { ForwardRef as ReactComponent };